/**
 * コースカードモード切替
 */
export default {
  modeNames: {
    list: 'リストモード',
    card: 'カードモード',
  },
}
